import React from 'react'
import PropTypes from 'prop-types'

import '../style.scss'

const PaywallModal = ({ title, description, action, children, onClose }) => {
  return (
    <>
      <div className="paywall-page" onClick={onClose}>
        <div className="paywall-container">
          <div className="paywall-wrapper" onClick={(e) => e.stopPropagation()}>
            <h1 className="font-size-36 mb-2 text-center">{title}</h1>
            <p className="mb-3 text-center">{description}</p>
            <div className="text-center">{action}</div>
          </div>
        </div>
      </div>
      <div className="blurred-page">{children}</div>
    </>
  )
}

PaywallModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default PaywallModal
